import { useSelector } from 'hooks/useSelector';
import { noop } from 'lodash';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Item } from 'screens/AssetsScreen/AssetList/Item/Item';
import { AssetListItemContainerProps } from 'screens/AssetsScreen/AssetList/Item/types';
import { ASSET_AVATAR } from 'service/api/constants';
import { TOGGLE_CHOSEN_SEARCH_ASSET } from 'store/actions';
import {
  selectChosenSearchAssetsCount,
  selectIsSearchAssetChosen,
  selectSearchAsset,
  selectSearchOrganisation,
} from 'store/search/selectors';

export const ListItem: React.FC<AssetListItemContainerProps> = ({
  cacheKey,
  id,
}) => {
  const dispatch = useDispatch();

  const toggleChosen = React.useCallback(
    () => dispatch(TOGGLE_CHOSEN_SEARCH_ASSET(id)),
    [dispatch, id],
  );

  const asset = useSelector((state) => selectSearchAsset(state, id));
  const organisation = useSelector((state) =>
    selectSearchOrganisation(state, asset.organisation_id),
  );
  const selectedCount = useSelector(selectChosenSearchAssetsCount);
  const selected = useSelector((state) => selectIsSearchAssetChosen(state, id));

  return (
    <Item
      asset={asset}
      selected={selected}
      organisation={organisation}
      onPressThumbnail={toggleChosen}
      onPress={toggleChosen}
      onLongPress={selectedCount ? noop : toggleChosen}
      remoteThumbnailUrl={
        asset.details.avatar ? ASSET_AVATAR(asset.id, cacheKey) : undefined
      }
    />
  );
};
